import { useSelector } from "react-redux";
import { AsyncModal } from "../async-modal/async-modal";
import { AXNUIBokuConsentFooter } from "@iddataweb/idw-common-ui/containers";
import { LanguageSelectorContainer } from "../language-selector/language-selector-container";
import { PostSubmitFormHelpTextContainer } from "../post-submit-form-help-text-container/post-submit-form-help-text-container";
import { getAvailableLanguages, getShowBokuConsentFooter, getIsLanguageSelectorEnabled } from "../../../redux/selectors/verification-configuration-selectors";
import { getAsyncMethod, getAsyncModalMessage, getHasMaximumDCUICancelRetries, getShowAsyncModal } from "../../../redux/selectors/verification-form-selectors";

type PostSubmitButtonContainerProps = {
    useThemedUI: boolean;
};

export const PostSubmitButtonContainer = (props: PostSubmitButtonContainerProps) => {
    const {
        useThemedUI
    } = props;

    const showBokuConsentFooter = useSelector(getShowBokuConsentFooter);
    const hasMaximumDCUICancelRetries = useSelector(getHasMaximumDCUICancelRetries);
    const asyncModalMessage = useSelector(getAsyncModalMessage);
    const availableLanguages = useSelector(getAvailableLanguages);
    const asyncMethod = useSelector(getAsyncMethod);
    const showAsyncModal = useSelector(getShowAsyncModal);
    const isLanguageSelectorEnabled = useSelector(getIsLanguageSelectorEnabled);

    return (
        <>
            {showAsyncModal && (
                <AsyncModal
                    asyncMethod={asyncMethod}
                    hasMaxRetries={hasMaximumDCUICancelRetries}
                    message={asyncModalMessage}
                />
            )}
            {!useThemedUI && showBokuConsentFooter && (
                <AXNUIBokuConsentFooter hasTopMargin={true} />
            )}
            {useThemedUI && (<PostSubmitFormHelpTextContainer />)}
            {((availableLanguages || []).length > 1 && isLanguageSelectorEnabled) && (
                <LanguageSelectorContainer useThemedUI={useThemedUI} />
            )}
        </>
    )
};